module.exports = __webpack_public_path__ + "48bd7d333d9def83cb105cb54a053ecf.pdf";